import React, { useState } from "react";
import PropTypes from "prop-types";
import "./SneaTabs.scss";

const SneaTabs = ({
  tabs,
  defaultActiveTab = 0,
  variant = "default",
  size = "default",
  orientation = "horizontal",
  className = "",
  onTabChange
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const handleTabClick = (index, tabId) => {
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(tabId, index);
    }
  };

  const getTabContainerClass = () => {
    let baseClass = "sneat-tabs";

    if (variant === "card") baseClass += " sneat-tabs-card";
    if (size === "sm") baseClass += " sneat-tabs-sm";
    if (size === "lg") baseClass += " sneat-tabs-lg";
    if (orientation === "vertical") baseClass += " sneat-tabs-vertical";

    return `${baseClass} ${className}`;
  };

  return (
    <div className={getTabContainerClass()}>
      <ul className="nav nav-tabs" role="tablist">
        {tabs.map((tab, index) => (
          <li key={tab.id || index} className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === index ? 'active' : ''}`}
              onClick={() => handleTabClick(index, tab.id)}
              type="button"
              role="tab"
              aria-selected={activeTab === index}
              disabled={tab.disabled}
            >
              {tab.icon && <i className={tab.icon}></i>}
              {tab.label}
              {tab.badge && (
                <span className={`badge ms-1 ${tab.badge.class || 'bg-primary'}`}>
                  {tab.badge.text}
                </span>
              )}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div
            key={tab.id || index}
            className={`tab-pane ${activeTab === index ? 'active' : ''}`}
            role="tabpanel"
          >
            {activeTab === index && tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

SneaTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      icon: PropTypes.string,
      disabled: PropTypes.bool,
      badge: PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        class: PropTypes.string
      })
    })
  ).isRequired,
  defaultActiveTab: PropTypes.number,
  variant: PropTypes.oneOf(["default", "card"]),
  size: PropTypes.oneOf(["sm", "default", "lg"]),
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  className: PropTypes.string,
  onTabChange: PropTypes.func
};

export default SneaTabs;